module.exports = __webpack_public_path__ + "img/2026babber-1.79d26cec.jpg";